
import BathroomTile1 from '../res/images/bathrooms/img1.jpeg';
import BathroomTile2 from '../res/images/bathrooms/img2.jpeg';
import BathroomTile3 from '../res/images/bathrooms/img3.jpeg';
import BathroomTile4 from '../res/images/bathrooms/img4.jpeg';
import BathroomTile5 from '../res/images/bathrooms/img5.jpeg';
import BathroomTile6 from '../res/images/bathrooms/img6.jpeg';
import BathroomTile7 from '../res/images/bathrooms/img7.jpeg';
import BathroomTile8 from '../res/images/bathrooms/img8.jpeg';
import BathroomTile9 from '../res/images/bathrooms/img9.jpeg';
import BathroomTile10 from '../res/images/bathrooms/img10.jpeg';
import BathroomTile11 from '../res/images/bathrooms/img11.jpeg';
import FloorTile12 from '../res/images/flooring/img12.jpeg';
import FloorTile13 from '../res/images/flooring/img13.jpeg';
import FloorTile14 from '../res/images/flooring/img14.jpeg';
import FloorTile15 from '../res/images/flooring/img15.jpeg';
import FloorTile16 from '../res/images/flooring/img16.jpeg';
import FloorTile17 from '../res/images/flooring/img17.jpeg';
import FloorTile18 from '../res/images/flooring/img18.jpeg';
import FloorTile19 from '../res/images/flooring/img19.jpeg';
import FloorTile20 from '../res/images/flooring/img20.jpeg';
import FloorTile21 from '../res/images/flooring/img21.jpeg';
import FloorTile22 from '../res/images/flooring/img22.jpeg';
import FloorTile23 from '../res/images/flooring/img23.jpeg';
import FloorTile24 from '../res/images/flooring/img24.jpeg';
import FloorTile25 from '../res/images/flooring/img25.jpeg';
import FloorTile26 from '../res/images/flooring/img26.jpeg';
import FloorTile27 from '../res/images/flooring/img27.jpeg';
import FloorTile28 from '../res/images/flooring/img28.jpeg';
import FloorTile29 from '../res/images/flooring/img29.jpeg';

export default function GetGalleryList() {
    return [
        {
            image: BathroomTile1,
            name: "PMP Certification Training",
            description: `A Trello board that I used to track my progress as I studied for the
            PMP certification.`,
            techUsed: ["TRELLO", "AGILE", "SCRUM"],
            githubLink: "",
            galleryLink: "https://trello.com/invite/b/68bb382ab5c220c248784c29/ATTI74add07905f63cb69705fec86a1a293b5B292348/pmp-training"
        },
        {
            image: BathroomTile2,
            name: "Vacation Planning",
            description: `A for-fun Tello board that I used to plan future dream vacations of mine.`,
            techUsed: ["ANSIBLE", "REACTJS", "NODEJS", "EXPRESSJS", "CSS"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: BathroomTile3,
            name: "Gallery #3",
            description: `This is placeholder text.`,
            techUsed: ["HTML", "CSS", "JAVASCRIPT"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: BathroomTile4,
            name: "Gallery #4",
            description: `This is placeholder text.`,
            techUsed: ["PHP", "POSTGRESSQL", "HTML", "CSS"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: BathroomTile5,
            name: "PMP Certification Training",
            description: `A Trello board that I used to track my progress as I studied for the
            PMP certification.`,
            techUsed: ["TRELLO", "AGILE", "SCRUM"],
            githubLink: "",
            galleryLink: "https://trello.com/invite/b/68bb382ab5c220c248784c29/ATTI74add07905f63cb69705fec86a1a293b5B292348/pmp-training"
        },
        {
            image: BathroomTile6,
            name: "Vacation Planning",
            description: `A for-fun Tello board that I used to plan future dream vacations of mine.`,
            techUsed: ["ANSIBLE", "REACTJS", "NODEJS", "EXPRESSJS", "CSS"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: BathroomTile6,
            name: "Gallery #3",
            description: `This is placeholder text.`,
            techUsed: ["HTML", "CSS", "JAVASCRIPT"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: BathroomTile8,
            name: "Gallery #4",
            description: `This is placeholder text.`,
            techUsed: ["PHP", "POSTGRESSQL", "HTML", "CSS"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: BathroomTile9,
            name: "PMP Certification Training",
            description: `A Trello board that I used to track my progress as I studied for the
            PMP certification.`,
            techUsed: ["TRELLO", "AGILE", "SCRUM"],
            githubLink: "",
            galleryLink: "https://trello.com/invite/b/68bb382ab5c220c248784c29/ATTI74add07905f63cb69705fec86a1a293b5B292348/pmp-training"
        },
        {
            image: BathroomTile10,
            name: "Vacation Planning",
            description: `A for-fun Tello board that I used to plan future dream vacations of mine.`,
            techUsed: ["ANSIBLE", "REACTJS", "NODEJS", "EXPRESSJS", "CSS"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: BathroomTile11,
            name: "Gallery #3",
            description: `This is placeholder text.`,
            techUsed: ["HTML", "CSS", "JAVASCRIPT"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: FloorTile12,
            name: "Gallery #3",
            description: `This is placeholder text.`,
            techUsed: ["HTML", "CSS", "JAVASCRIPT"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: FloorTile13,
            name: "Gallery #3",
            description: `This is placeholder text.`,
            techUsed: ["HTML", "CSS", "JAVASCRIPT"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: FloorTile14,
            name: "Gallery #3",
            description: `This is placeholder text.`,
            techUsed: ["HTML", "CSS", "JAVASCRIPT"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: FloorTile15,
            name: "Gallery #3",
            description: `This is placeholder text.`,
            techUsed: ["HTML", "CSS", "JAVASCRIPT"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: FloorTile16,
            name: "Gallery #3",
            description: `This is placeholder text.`,
            techUsed: ["HTML", "CSS", "JAVASCRIPT"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: FloorTile17,
            name: "Gallery #3",
            description: `This is placeholder text.`,
            techUsed: ["HTML", "CSS", "JAVASCRIPT"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: FloorTile18,
            name: "Gallery #3",
            description: `This is placeholder text.`,
            techUsed: ["HTML", "CSS", "JAVASCRIPT"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: FloorTile19,
            name: "Gallery #3",
            description: `This is placeholder text.`,
            techUsed: ["HTML", "CSS", "JAVASCRIPT"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: FloorTile20,
            name: "Gallery #3",
            description: `This is placeholder text.`,
            techUsed: ["HTML", "CSS", "JAVASCRIPT"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: FloorTile21,
            name: "Gallery #3",
            description: `This is placeholder text.`,
            techUsed: ["HTML", "CSS", "JAVASCRIPT"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: FloorTile22,
            name: "Gallery #3",
            description: `This is placeholder text.`,
            techUsed: ["HTML", "CSS", "JAVASCRIPT"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: FloorTile23,
            name: "Gallery #3",
            description: `This is placeholder text.`,
            techUsed: ["HTML", "CSS", "JAVASCRIPT"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: FloorTile24,
            name: "Gallery #3",
            description: `This is placeholder text.`,
            techUsed: ["HTML", "CSS", "JAVASCRIPT"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: FloorTile25,
            name: "Gallery #3",
            description: `This is placeholder text.`,
            techUsed: ["HTML", "CSS", "JAVASCRIPT"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: FloorTile26,
            name: "Gallery #3",
            description: `This is placeholder text.`,
            techUsed: ["HTML", "CSS", "JAVASCRIPT"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: FloorTile27,
            name: "Gallery #3",
            description: `This is placeholder text.`,
            techUsed: ["HTML", "CSS", "JAVASCRIPT"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: FloorTile28,
            name: "Gallery #3",
            description: `This is placeholder text.`,
            techUsed: ["HTML", "CSS", "JAVASCRIPT"],
            githubLink: "",
            galleryLink: "#"
        },
        {
            image: FloorTile29,
            name: "Gallery #3",
            description: `This is placeholder text.`,
            techUsed: ["HTML", "CSS", "JAVASCRIPT"],
            githubLink: "",
            galleryLink: "#"
        }
    ]

}
